import { render, staticRenderFns } from "./AssetMetadata.vue?vue&type=template&id=1eb13526&scoped=true"
import script from "./AssetMetadata.vue?vue&type=script&lang=js"
export * from "./AssetMetadata.vue?vue&type=script&lang=js"
import style0 from "./AssetMetadata.vue?vue&type=style&index=0&id=1eb13526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb13526",
  null
  
)

export default component.exports